import { render, staticRenderFns } from "./AddData.vue?vue&type=template&id=354ecd02&"
import script from "./AddData.vue?vue&type=script&lang=js&"
export * from "./AddData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports